import { RangeSlider } from '..';
import moment from 'moment';

import type { TimestampInMillis } from '@cobliteam/common-types';

interface TimeRangeSliderProps {
  handleChange?: (leftValue: number, rightValue: number) => void;
  handleAfterChange?: (leftValue: number, rightValue: number) => void;
  step: TimestampInMillis;
  leftValue: number;
  rightValue: number;
  leftLimit: number;
  rightLimit: number;
  minInterval: TimestampInMillis;
}

export const format = (valueInMillis: number): string => {
  if (valueInMillis < 0) {
    throw new Error('Formatting negative number of minutes is not possible');
  }

  const date = moment(valueInMillis);

  return `${date.format('HH')}:${date.format('mm')}`;
};

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const TimeRangeSlider = (props: TimeRangeSliderProps) => (
  <RangeSlider
    handleFormat={format}
    leftLimit={props.leftLimit}
    rightLimit={props.rightLimit}
    step={props.step}
    leftValue={props.leftValue}
    rightValue={props.rightValue}
    minInterval={props.minInterval}
    handleChange={props.handleChange}
    handleAfterChange={props.handleAfterChange}
  />
);

export default TimeRangeSlider;
